import axios, { AxiosResponse } from 'axios'
import { ID } from '../../../../../../_metronic/helpers'
import { ApiTokenReponse } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const EMPRESA_URL = `${API_URL}/empresas`

/**
 * Gera chave para API de integração
 * @param idEmpresa Identificador da Empresa
 * @returns ApiTokenReponse
 */
export const gerarToken = (idEmpresa: ID): Promise<ApiTokenReponse> => {
  return axios
    .post(`${EMPRESA_URL}/integracao/${idEmpresa}`)
    .then((response: AxiosResponse<ApiTokenReponse>) => response.data)
}

/**
 * Invalida chave da API de Integração
 * @param idEmpresa Identificador da empresa
 * @returns ApiTokenReponse
 */
export const invalidateToken = (idEmpresa: ID): Promise<ApiTokenReponse> => {
  return axios
    .delete(`${EMPRESA_URL}/integracao/${idEmpresa}`)
    .then((response: AxiosResponse<ApiTokenReponse>) => response.data)
}
